// extracted by mini-css-extract-plugin
module.exports = {"content":"SaleItemMovileViewColumn_content__rJv32","actions":"SaleItemMovileViewColumn_actions__kC9gx"};